import type { DomainConvertInfo } from '@core/core/types'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

export const velocityDomainAdapter = createEntityAdapter<DomainConvertInfo>({
  selectId: entity => entity.projectId,
})

const initialState = velocityDomainAdapter.getInitialState()
export const velocityDomainsSlice = createSlice({
  name: 'velocityDomains',
  initialState,
  reducers: {
    clearVelocityDomains() {
      return initialState
    },
    addVelocityDomains(state, action: PayloadAction<DomainConvertInfo>) {
      velocityDomainAdapter.upsertOne(state, action.payload)
    },
  },
})

export default velocityDomainsSlice.reducer
